import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import React from 'react';import PropTypes from 'prop-types';
import { CancelationOptionsStep, PaymentOptionsStep, SummaryStep } from './Canceling';
import Breadcrumbs from '../../components/Breadcrumbs';
import { Icon } from '../../../common/components';
import { selectors, actions } from '../../../modules/customer/profile/hardwareProducts';
import { hardwareProducts, selectors as profileSelectors } from '../../../modules/customer/profile';
import { actions as formActions } from '../../../modules/form';
import FormContainer from './../../components/FormContainer';
import FormConfirmationScreen from '../../../common/components/FormConfirmationScreen';

const steps = [
    {
        stepNumber: 1,
        stepTitle: "Produkter",
        stepBody: <CancelationOptionsStep />,
        isStepValidSelector: selectors.isHardwareProductsToCancelSelected,
    },
    // {
    //     stepNumber: 2,
    //     stepTitle: "Payment options",
    //     stepBody: <PaymentOptionsStep />,
    //     isStepValidSelector: () => true,

    // },
    {
        stepNumber: 2,
        stepTitle: "Oppsummering",
        stepBody: <SummaryStep />,
        isStepValidSelector: () => true,

    },
];

const timer = timeout => (function () {
    let isLoading = true;
    setTimeout(function() { isLoading = false; }, timeout);
    return isLoading;
}());

const formName ="CancelingProductsForm"
const ProductCancellation = ({cancelSelectedProducts, abortCancellation, customerId}) => {
    return (       
            <FormContainer className="productCancellation"
                formName={formName}
                formTitle="Kansellering utstyr"
                stepsList={steps}
                confirmStepAction={cancelSelectedProducts}
                onAbortHandler={abortCancellation}
                showConfirmationScreen={true}
                confirmationScreenBody={<FormConfirmationScreen 
                                     formName = {formName}                                     
                                     redirectUrl = {"/customer/" + customerId}
                                     isLoadingSelector = {() => false }
                                     requestSuccessfulSelector = {() => true}
                                />}
                />        
    );
};

const mapStateToProps = createStructuredSelector({
    customerId: profileSelectors.getCustomerID,    
})

const mapDispatchToProps = (dispatch, getState) => ({
    cancelSelectedProducts: formName => dispatch(hardwareProducts.actions.cancelHardwareProducts(formName)),
    abortCancellation: formName => dispatch(formActions.resetForm(formName))
    .then(() => dispatch(hardwareProducts.actions.clearCancelHardwareFormData()))
    .then(() => dispatch(hardwareProducts.actions.backToProfileView))    
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductCancellation);